/* eslint-disable react/no-unknown-property */

import { RootState } from '@/stores'
import { useSelector } from 'react-redux'
import ForceArrow3D from './viewer/ForceArrow3D'

type PropTypes = {
  position?: [number, number, number]
}

const TBoltForceDisplay = ({ position = [0, 0, 0] }: PropTypes) => {
  const { design, selectedComponentId } = useSelector((state: RootState) => state.activeDesign)
  const tBolt = design?.components.find(c => c.id === selectedComponentId)?.t_bolt

  return (
    <group position={position}>
      {
        tBolt && tBolt.tension_force
          && (
            <ForceArrow3D
              points={[[0, 0, 0], [0, 50, 0]]}
              label={`${tBolt.tension_force}kN`}
            />
          )
      }
      {
        tBolt && tBolt.shear_force
          && (
            <ForceArrow3D
              points={[[0, 0, 0], [0, 0, 50]]}
              label={`${tBolt?.shear_force}kN`}
            />
          )
      }
    </group>
  )
}

export default TBoltForceDisplay
